<!-- 新增期初记账操作 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle"  append-to-body :close-on-click-modal="false" center  width="50%" top="2rem">
			<el-form size="mini" label-position="left" label-width="120px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="期初金额">
							<el-input v-model="sendDataInfo.beginAccount" type="number"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="货主">
							<el-input v-model="sendDataInfo.coName" @focus="$refs['showSelectData'].openBox('cargoOwnerList','cargoOwnerList','coId')"></el-input>
						</el-form-item>
					</el-col>
					
					<el-col :span="24">
						<el-form-item label="我方业务员">
							<el-select v-model="sendDataInfo.salesId" >
								<el-option v-for="(values,keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="期初类型">
							<el-radio-group v-model="sendDataInfo.beginType">
							    <el-radio-button  :label="0">供应商</el-radio-button>
							    <el-radio-button  :label="1">客户</el-radio-button>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="sendDataInfo.beginType==0">
						<el-form-item label="供应商">
							<el-input v-model="sendDataInfo.unitName" @focus="$refs['showSelectData'].openBox('supplierList','supplierList','smId')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="sendDataInfo.beginType==1">
						<el-form-item label="客户">
							<el-input v-model="sendDataInfo.unitName"  @focus="$refs['showSelectData'].openBox('customerList','customerList','cmId')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="对方业务员">
							<el-select   v-model="sendDataInfo.opposalesId">
								<el-option  label="请选择业务员" value="">
								</el-option>
								<el-option v-for="(values,keys) in salesmanList" :key="keys" :label="values.name" :value="values.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'initBookkeepingAction',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				"coId": "",
				"coName": "",
				"unitId": "",
				"unitName": "",
				"beginType": 0,
				salesId:"",  // 我方业务员
				opposalesId:"",  // 对方业务员
				beginAccount:0,
			
			},
			salesmanList:[],
			userOneList:[],
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
		'sendDataInfo.beginType':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.sendDataInfo.unitId = ''
					this.sendDataInfo.unitName = ''
				}
			},
			deep:true,
		}
	},
    //方法集合
    methods: {
		// 获取我方业务员
		async getSpecialUser(){
			this.userOneList = []
			let responseData =  await this.$http.getSpecialUser({opmSalesperson:1})
			if(responseData.status == 200){
				this.userOneList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		async isShowData(name,value){
			switch(name){
				case 'supplierList':
					var dataInfo = sessionStorage.getItem('selectSupplierData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.unitId = dataInfo.smId
						this.sendDataInfo.unitName	 = dataInfo.smName	
						
					}
					this.getUnitSalesmanList()
				break;
				case 'customerList':
					var dataInfo = sessionStorage.getItem('selectCustomerData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.unitId = dataInfo.cmId
						this.sendDataInfo.unitName	 = dataInfo.cmName	
						
					}
					this.getUnitSalesmanList()
				break;
				case 'cargoOwnerList':
					var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.coId = dataInfo.coId
						this.sendDataInfo.coName = dataInfo.coName
					}
					
				break;
				default:
					this.sendDataInfo[name] = value
				
			}
			
		},
		
		// 获取对方业务员
		async getUnitSalesmanList(){
			this.salesmanList = []
			let responseData =  await this.$http.getUnitSalesmanList({ids:[this.sendDataInfo.unitId]})
			if(responseData.status == 200){
				this.salesmanList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
	
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.sendDataInfo.beginType = 0;
			this.sendDataInfo.beginAccount = 0;
			this.getSpecialUser()
			this.dataActionBox.showStatus = false
		},
		
	
		
		openBox(cate,oldData={}){
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增对期初财务信息'
			}else{
				this.dataActionBox.boxTitle = '编辑期初财务信息'
				this.sendDataInfo = oldData
			
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.beginAccount	==''){
				this.$message({
					message: '请填写期初金额',
					type: 'error'
				});
				return false
			}
			var sendPostData = JSON.parse(JSON.stringify(this.sendDataInfo))
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addInitBookkeeping(sendPostData)
			}
			
			
			if(responseData.status == 200){
				this.initActionBox()
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>